export default "__VITE_ASSET__6ad87cf6__"